import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-circle-progress-bar', {
  mixins: [eventListenerMixin],

  properties: {
    currentItems: Number,
    totalItems: Number,
  },

  ready() {
    this.renderProgressBar();
  },

  renderProgressBar() {
    const progress = parseInt(this.currentItems / this.totalItems * 100, 10);
    const circle = this.querySelector('.circle');
    const leftSide = this.querySelector('.left-side');
    const rightSide = this.querySelector('.right-side');
    const rotate = progress * 3.6;

    leftSide.setAttribute('style', `transform: rotate(${rotate}deg)`);
    if (progress <= 50) {
      rightSide.classList.add('lower-50');
    } else {
      rightSide.classList.add('higher-50');
      circle.setAttribute('style', 'clip: rect(auto, auto, auto, auto)');
    }
  },
});
